import { useQuery } from "@tanstack/react-query";
import api from "../api";

// Helper function برای چک کردن rate limit status
const checkRateLimitStatus = () => {
  const isRateLimited = localStorage.getItem("rateLimitActive") === "true";
  const startTime = localStorage.getItem("rateLimitStartTime");
  
  if (isRateLimited && startTime) {
    const elapsed = Math.floor((Date.now() - parseInt(startTime)) / 1000);
    const RATE_LIMIT_DURATION = 15 * 60; // 15 دقیقه
    
    // اگه زمان گذشته، flag ها رو پاک کن
    if (elapsed >= RATE_LIMIT_DURATION) {
      localStorage.removeItem("rateLimitActive");
      localStorage.removeItem("rateLimitStartTime");
      return false;
    }
    return true;
  }
  
  return false;
};

export const useAuth = () => {
  const isRateLimited = checkRateLimitStatus();
  
  return useQuery({
    queryKey: ["auth"],
    queryFn: async () => {
      try {
        const res = await api.get("/auth/check");
        
        // اگه موفق شد، rate limit رو پاک کن
        localStorage.removeItem("rateLimitActive");
        localStorage.removeItem("rateLimitStartTime");
        
        return res.data;
      } catch (error) {
        // اگه request از interceptor کنسل شده (rate limit active)
        if (error.isRateLimitActive) {
          return {
            isAuthenticated: false,
            user: null,
            error: "Rate limit active",
          };
        }
        
        if (error.response?.status === 401 || error.response?.status === 403) {
          return {
            isAuthenticated: false,
            user: null,
            error: "شما به حساب خود وارد نشده اید",
          };
        }
        
        // اگه rate limit خورد
        if (error.response?.status === 429) {
          if (!localStorage.getItem("rateLimitStartTime")) {
            localStorage.setItem("rateLimitStartTime", Date.now().toString());
          }
          localStorage.setItem("rateLimitActive", "true");
          return {
            isAuthenticated: false,
            user: null,
            error: "Rate limit exceeded",
          };
        }
        
        throw error;
      }
    },
    retry: (failureCount, error) => {
      // اگه rate limit خورد یا request کنسل شده، retry نکن
      if (error?.response?.status === 429 || error?.isRateLimitActive) return false;
      return failureCount < 1;
    },
    staleTime: 1 * 60 * 1000,
    gcTime: 1 * 60 * 1000,
    enabled: !isRateLimited, // غیرفعال کردن وقتی rate limited هستیم
    refetchOnWindowFocus: !isRateLimited,
    refetchOnReconnect: !isRateLimited,
  });
};

export const useUser = () => {
  const { data, isLoading, error } = useAuth();

  return {
    user: data?.user || null,
    isAuthenticated: data?.isAuthenticated || false,
    isLoading,
    error,
  };
};
